import { ReactNode } from 'react'

import BlurredText from '../blurred-text'
import { BlluredTextVariants } from '../blurred-text/blurred-text.css'

type BlurredContentLoaderProps = {
  blurred: boolean
  children: ReactNode
  blurredText?: string
  blurredTextVariant?: BlluredTextVariants
}

const BlurredContentLoader = ({
  blurred,
  blurredText = '****',
  blurredTextVariant = { size: 'regular', weight: 'strong' },
  children
}: BlurredContentLoaderProps) => {
  return blurred ? (
    <BlurredText variant={blurredTextVariant}>{blurredText}</BlurredText>
  ) : (
    children
  )
}

export default BlurredContentLoader
